// extracted by mini-css-extract-plugin
module.exports = {"no-logo":"index-module_no-logo_5gxiS","download-button":"index-module_download-button_2tKmR"};